import React from 'react';
import Title from '../../../../../@casino/ui/title';
import { useDispatch, useSelector } from 'react-redux';
import { useForm, useWatch } from 'react-hook-form';
import { makeStyles } from '@material-ui/core';
import FieldInput from '../../../../../@casino/ui/Fields/Input';
import FieldSelect from '../../../../../@casino/ui/Fields/Select';
import FieldsButton from '../../../../../@casino/ui/Fields/Button';
import FieldsDatePicker from '../../../../../@casino/ui/Fields/DatePicker';
import TableCasino from '../../../../../@casino/ui/table';
import ModalAddMailing from '../../components/ModalAddMailing';
import { setGetTransactionReport } from '../../store/thunk/setGetTransactionReport';
import { format } from 'date-fns';

const useStyles = makeStyles(() => ({
    root: {
        padding: 20,
        paddingTop: 0
    },
    wrap: {
        padding: 20,
        background: '#1b2039',
        borderRadius: 8,
        marginBottom: 12,
        display: 'flex',
        gap: '10px',
        flexDirection: 'column'
    },
    btn: {
        padding: '3px 14px',
        borderRadius: 4,
        background: '#ffc324',
        color: '#141b33',
        cursor: 'pointer',
        border: 'none',
        fontSize: 16
    },
}))

const TransactionReport = () => {
    const classes = useStyles();
    const dispatch = useDispatch();

    const LIST_CURRENCY = [{
        label: 'RUB',
        value: 'RUB'
    }, {
        label: 'KZT',
        value: 'KZT'
    }, {
        label: 'UZS',
        value: 'UZS'
    }, {
        label: 'USD',
        value: 'USD'
    }, {
        label: 'EUR',
        value: 'EUR'
    }, {
        label: 'GEL',
        value: 'GEL'
    }, {
        label: 'TRY',
        value: 'TRY'
    }];

    const LIST_STATUS = [{
        label: 'Оплачен',
        value: 'paid'
    }, {
        label: 'Создан',
        value: 'ready_for_pay'
    }];

    const {
        register,
        handleSubmit,
        control,
        setValue
    } = useForm({
        mode: 'onChange',
        defaultValues: {
            login: '',
            currency: '',
            status: '',
            from_date: '',
            to_date: '',
            orderBy: 'sum,desc'
        }
    })

    const [login, currency, from_date, to_date, orderBy, status] = useWatch({
        control,
        name: ['login', 'currency', 'from_date', 'to_date', 'orderBy', 'status']
    });

    const [selectedLogin, setSelectedLogin] = React.useState(undefined);
    const [isOpenModalAddMailing, setIsOpenModalAddMailing] = React.useState(false);


    const onSubmit = (store) => {
        dispatch(setGetTransactionReport({
            ...store,
            page: 1,
            pageSize: 50
        }))
    }

    const columns = [
        { id: 'data', label: 'Дата'},
        { id: 'login', label: 'Логин'},
        { id: 'sum', label: 'Сумма'},
        { id: 'currency', label: 'Валюта'},
        { id: 'status', label: 'Статус'},
        { id: 'settings', label: 'Рассылка'}
    ];

    
    const handleIsOpenModalAddMailing = ({
        login
    }) => {
        setIsOpenModalAddMailing(value => !value)
        setSelectedLogin(login)
    }
    

    
    const getRows = (data) => {
        return data?.list?.map((item, key) => {
            return {
                id: key + 1,
                data: format(new Date(Number(item.data)), 'dd.MM.yyyy HH:mm'),
                login: item.login || '-',
                sum: new Intl.NumberFormat('ru-RU').format(item.amount),
                currency: item.currency || '-',
                status: item.status === 'paid' ? 'Оплачен' : 'Создан',
                settings: (
                    <button
                        type="button"
                        onClick={() => handleIsOpenModalAddMailing({login: item.login})}
                        className={classes.btn}
                    >
                        Добавить
                    </button>
                )
            }
        })
    }

    const data = useSelector((state) => state.replenishmentTransactionReport.transaction);

    const rows = React.useMemo(() => getRows(data), [data]);

    const handleChangeModeAddMailing = () => {
        setIsOpenModalAddMailing(false);
        setSelectedLogin(undefined)
    }

    return (
        <div className={classes.root}>
            <Title label="Транзакции" />
            <form onSubmit={handleSubmit(onSubmit)} className={classes.wrap}>
                <div style={{width: 600}}>  
                    <FieldsDatePicker
                        register={register}
                        label="Период депозита"
                    />
                </div>
                
                <div style={{ display: 'flex', columnGap: 20 }}>
                    <FieldInput
                        name="login"
                        placeholder="Поиск по логину"
                        register={register}
                    />
                    <FieldSelect
                        register={register}
                        label="Валюта"
                        name="currency"
                        list={LIST_CURRENCY}
                        defaultOption="Выбрать валюту"
                    />
                    <FieldSelect
                        register={register}
                        label="Статус"
                        name="status"
                        list={LIST_STATUS}
                        defaultOption="Выбрать статус"
                    />
                </div>

                
                <div style={{ display: 'flex', columnGap: 10, alignItems: 'center' }}>
                    <FieldsButton
                        type="submit"
                        label="Поиск"
                    />
                </div>
            </form>
            <div className={classes.wrap}>
                <TableCasino
                    perPage={50}
                    columns={columns}
                    rows={rows}
                    pagination
                    allPage={data.totalPage}
                     orderByDefault="sum,desc"
                     order={(v) => {
                        setValue(`orderBy`, `${v.id},${v.sort}`);
                        dispatch(setGetTransactionReport({
                            login,
                            currency,
                            status,
                            from_date,
                            to_date,
                            page: 1,
                            pageSize: v.rowsPerPage,
                            orderBy: `${v.id},${v.sort}`
                        }))
                    }}
                    changePage={(v) =>
                        dispatch(setGetTransactionReport({
                            login,
                            currency,
                            status,
                            from_date,
                            to_date,
                            page: +v.page + 1,
                            pageSize: v.rowsPerPage,
                            orderBy
                        }))
                    }
                    changeRowsPerPage={(v) => dispatch(setGetTransactionReport({
                        login,
                        currency,
                        status,
                        from_date,
                        to_date,
                        page: 1,
                        pageSize: v.rowsPerPage,
                        orderBy
                    }))}
                />
            </div>
            {
                isOpenModalAddMailing && (
                    <ModalAddMailing handleChangeModeAddMailing={handleChangeModeAddMailing} login={selectedLogin} />
                )
            }
           
        </div>
    )
}

export default TransactionReport;